/** UTC calendar-day helpers. Days are the public playback granularity. */

const DAY_MS = 86_400_000;

/** 'YYYY-MM-DD' (UTC) for a unix-ms timestamp. */
export function dayKey(tsMs: number): string {
  return new Date(tsMs).toISOString().slice(0, 10);
}

export function isDayKey(s: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(s) && !Number.isNaN(Date.parse(s + 'T00:00:00Z'));
}

/** Unix-ms of the start of the UTC day. */
export function dayStartMs(day: string): number {
  return Date.parse(day + 'T00:00:00Z');
}

/** Unix-ms of the end of the UTC day (exclusive). */
export function dayEndMs(day: string): number {
  return dayStartMs(day) + DAY_MS;
}

export function nextUtcMidnightMs(tsMs: number): number {
  return Math.floor(tsMs / DAY_MS) * DAY_MS + DAY_MS;
}

export function addDays(day: string, n: number): string {
  return dayKey(dayStartMs(day) + n * DAY_MS);
}

/** Local calendar day for a timestamp and a UTC offset in minutes. */
export function localDayKey(tsMs: number, tzOffsetMinutes: number): string {
  return dayKey(tsMs + tzOffsetMinutes * 60_000);
}

export function localHour(tsMs: number, tzOffsetMinutes: number): number {
  return new Date(tsMs + tzOffsetMinutes * 60_000).getUTCHours();
}

/** 0 = Sunday … 6 = Saturday, in local time. */
export function localWeekday(tsMs: number, tzOffsetMinutes: number): number {
  return new Date(tsMs + tzOffsetMinutes * 60_000).getUTCDay();
}
